module.exports = __webpack_public_path__ + "static/media/empty-user.3cbf7fb3.svg";